import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './OpenCardScreen.css';
import CardDetailScreen from './CardDetailScreen';
import CARD_DETAILS from './cardDetails';
import { createCard } from './cardsStore';
import { getStoredChatId } from './chatId';

const CLOSE_MS = 320; // синхронізовано з анімацією закриття в OpenCardScreen.css

// icon — мініатюра, вирізана зі скріншота «Усі картки» (public/card-icons);
// variant — мініатюра, намальована в CSS
const CARD_TYPES = [
  { id: 'kids', label: 'Дитяча', variant: 'kids' },
  { id: 'evidnovlennia', label: 'єВідновлення', variant: 'evidnovlennia' },
  { id: 'diia', label: 'Дія.Картка', variant: 'diia' },
  { id: 'white', label: 'Біла', icon: '/card-icons/white.png' },
  { id: 'usd', label: 'Доларова', icon: '/card-icons/usd.png' },
  { id: 'eur', label: 'Єврова', icon: '/card-icons/eur.png' },
  { id: 'cashback', label: 'Національний кешбек', icon: '/card-icons/cashback.png' },
];

// Екран «Відкрити картку» — виїжджає справа поверх усього, стрілка назад
// повертає на головну. cards — уже відкриті картки (useUserCards);
// onCardOpened(cardId) — картку записано в БД (або вона вже була),
// головна гортає до неї.
export default function OpenCardScreen({ cards = [], onClose, onCardOpened }) {
  const [closing, setClosing] = useState(false);
  // відкритий опис картки (ключ у CARD_DETAILS)
  const [detailId, setDetailId] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  function close() {
    if (closing) return;
    setClosing(true);
    timerRef.current = setTimeout(onClose, CLOSE_MS);
  }

  // CTA «Хочу … картку»: створюємо картку в БД (одна на тип) і закриваємо
  // обидва екрани разом. false — лишаємось на екрані картки.
  async function openCard(type) {
    let cardId = cards.find((c) => c.type === type)?.id;
    if (!cardId) {
      try {
        cardId = await createCard(getStoredChatId(), type);
      } catch (e) {
        window.alert('Не вдалося відкрити картку. Спробуйте ще раз');
        return false;
      }
    }
    if (onCardOpened) onCardOpened(cardId);
    close();
    return true;
  }

  return createPortal((
    <div className={`ocs-root ${closing ? 'closing' : ''}`}>
      <div className="ocs-screen">
        <button type="button" className="ocs-back" onClick={close} aria-label="Назад">
          <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 8H1.5M8 1.2L1.2 8L8 14.8" fill="none" stroke="#e0e0e0" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <h1 className="ocs-title">Відкрити картку</h1>

        <div className="ocs-status">
          <img className="ocs-status-img" src="/open-card-cat.png" alt="" />
          <p className="ocs-status-title">Підвищити статус картки</p>
          <p className="ocs-status-sub">
            Нанести ім'я на картку або отримати доступ в<br />
            лаунж, fast-line і безкоштовну турстраховку
          </p>
        </div>

        <p className="ocs-section">Картки</p>
        <div className="ocs-types">
          {/* уже відкриті картки (одна на тип) повторно не пропонуємо */}
          {CARD_TYPES.filter((t) => !cards.some((c) => c.type === t.id)).map((t) => (
            <div
              className={`ocs-type ${CARD_DETAILS[t.id] ? 'clickable' : ''}`}
              key={t.id}
              onClick={CARD_DETAILS[t.id] ? () => setDetailId(t.id) : undefined}
            >
              <div className="ocs-type-icon">
                {t.icon
                  ? <img className="ocs-mini-img" src={t.icon} alt="" />
                  : <div className={`ocs-mini ${t.variant}`} />}
              </div>
              <p className="ocs-type-label">{t.label}</p>
            </div>
          ))}
        </div>
      </div>
      {detailId && (
        <CardDetailScreen
          detail={CARD_DETAILS[detailId]}
          opened={cards.some((c) => c.type === detailId)}
          onClose={() => setDetailId(null)}
          onCta={() => openCard(detailId)}
        />
      )}
    </div>
  ), document.body);
}
